import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Card, CardContent, Container, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import HomeIcon from '@mui/icons-material/Home';

export default function NotFound() {
  const theme = useTheme();
  const ACCENT = theme.tokens.accent;
  const ACCENT_LIGHT = alpha(ACCENT, 0.08);
  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Card
        variant="outlined"
        sx={{
          width: '100%',
          borderRadius: 2,
          boxShadow: `0 4px 20px ${alpha(ACCENT, 0.08)}`,
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            bgcolor: ACCENT_LIGHT,
            borderBottom: `2px solid ${alpha(ACCENT, 0.18)}`,
            py: 4,
            px: 2,
            textAlign: 'center',
          }}
        >
          <SearchOffIcon sx={{ fontSize: 64, color: ACCENT, mb: 1 }} />
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: 72, sm: 96 },
              fontWeight: 700,
              color: ACCENT,
              lineHeight: 1.1,
            }}
          >
            404
          </Typography>
        </Box>
        <CardContent sx={{ textAlign: 'center', py: 4, px: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary', mb: 1 }}>
            Page not found
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            The page you are looking for does not exist or has been moved. Check the address or use
            the menu to navigate.
          </Typography>
          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            startIcon={<HomeIcon />}
            sx={{
              bgcolor: ACCENT,
              '&:hover': { bgcolor: alpha(ACCENT, 0.85) },
              py: 1.25,
              px: 3,
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Back to Home
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
}
